import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { LocalDatePipe } from '../../pipes/local-date.pipe';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-date-label',
  templateUrl: './date-label.component.html',
  imports: [TranslatePipe, LocalDatePipe],
})
export class DateLabelComponent {
  @Input() applyStyling = true;
  today: Date;

  constructor() {
    const date = new Date();
    this.today = this.convertToUTC(date);
  }

  private convertToUTC(date: Date): Date {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const day = date.getUTCDate();
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();
    const now_utc = Date.UTC(year, month, day, hours, minutes, seconds);
    return new Date(now_utc);
  }
}
